import { useEffect, useState } from 'react';

const MIN_SEARCH_LENGTH = 3;
const SEARCH_DELAY_MS = 500;

// Keep typing local to the input. Server filters are updated only after the
// user pauses and the query is specific enough to be useful.
const useDebouncedForecastSearch = () => {
  const [searchInput, setSearchInput] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      const value = searchInput.trim();
      setSearchQuery(value.length >= MIN_SEARCH_LENGTH ? value : '');
    }, SEARCH_DELAY_MS);

    return () => window.clearTimeout(timeout);
  }, [searchInput]);

  const clearSearch = () => {
    setSearchInput('');
    setSearchQuery('');
  };

  return { searchInput, setSearchInput, searchQuery, clearSearch };
};

export default useDebouncedForecastSearch;
